import React, { useEffect, useState } from "react";
import "./Style.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Assets/Delete.svg";
import selectedstar from "../../../Assets/book-red.png";
import unselectedstar from "../../../Assets/book-white.png";
import {
  APISalesforceUrl,
  APIDataUrl,
  APITokenUrl,
  GetUserId,
} from "../../../Utils/Utils";
import { AI_PROFILE_FORM_TABLE } from "../../../Utils/Constants";
import axios from "axios";
import Loader from "../../Loader/Loader";
import { toast } from "react-toastify";
import moment from "moment";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import privateLock from "../../../Assets/privateLock.svg";
import * as XLSX from "xlsx";
import publicLock from "../../../Assets/publicLock.svg";
import { Box, IconButton, Typography } from "@mui/material";
export default function LeadsProfileTable({
  setRefState,
  isDecisionMakerExcel,
  setIsDecisionMakerExcel,
  shareRecord,
  setShareRecord,
  
  
}) {
  const navigate = useNavigate();
  const loggedInUserId = GetUserId();
  const [selectedStar, setSelectedStar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [leadsProfileData, setLeadsProfileData] = useState([]);
  const [selectedOuterRows, setSelectedOuterRows] = React.useState([]);
  const [isLeadProfile, setIsLeadProfile] = useState(false);
  const [rowsSelectAll, setRowsSelectAll] = React.useState(false);
  const userId = GetUserId();
  const handleStarClick = (item) => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/set_default_org_filter?name=${
        item.name
      }&user_id=${loggedInUserId}`,
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        if (response?.status === 200) {
          setRefState(true);
          setSelectedStar(item?.key === selectedStar ? null : item?.key);
          toast.success(response?.data?.message);
          LeadsProfile();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  const handlePrivacyClick = (item) => {
    setLoading(true);
    let data = { ...item };
    data.public = !item.public;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/update_filter_org`,
      data: JSON.stringify(data),
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        if (response?.status === 200) {
          LeadsProfile();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  const handleDelete = (item) => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/delete_org_filter?name=${
        item.name
      }&user_id=${loggedInUserId}`,
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        if (response?.status === 200) {
          setRefState(true);
          LeadsProfile();
          toast.success(response?.data?.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  const LeadsProfile = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/get_filter_org?user_id=${userId}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          let data = e?.data?.data
            ? [...e.data.data].sort((a, b) => {
                if (a.default && !b.default) return -1;
                if (!a.default && b.default) return 1;
                return b.id - a.id;
              })
            : [];
          setLeadsProfileData(data);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (userId && isLeadProfile) {
      LeadsProfile();
    } else setIsLeadProfile(true);
  }, [userId, isLeadProfile]);
  const handleRowSelect = (row) => {
    setSelectedOuterRows((prevSelectedRows) => {
      const isAlreadySelected = prevSelectedRows.some(
        (item) => item.id === row.id,
      );
      if (isAlreadySelected) {
        return prevSelectedRows.filter((item) => item.id !== row.id);
      } else {
        return [...prevSelectedRows, row];
      }
    });
  };
  React.useEffect(() => {
    if (rowsSelectAll) {
      const allRows = [...leadsProfileData];
      setSelectedOuterRows(allRows);
    } else if (rowsSelectAll === false) {
      setSelectedOuterRows([]);
    } else if (selectedOuterRows?.length == leadsProfileData?.length) {
      setRowsSelectAll(true);
    } else if (selectedOuterRows?.length < leadsProfileData?.length) {
      setRowsSelectAll(false);
    }
  }, [rowsSelectAll]);
  const exportToExcel = (data, filename) => {
    const filteredData = data.map(
      ({ person_id, org_id, strengthData, ...rest }) => rest,
    );
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${filename}.xlsx`);
    setIsDecisionMakerExcel(false);
    setSelectedOuterRows([]);
    setRowsSelectAll(false);
  };
  React.useEffect(() => {
    if (isDecisionMakerExcel) {
      if (!selectedOuterRows?.length) {
        toast.error("Please select records to download");
        setIsDecisionMakerExcel(false);
        return;
      }
      exportToExcel(selectedOuterRows, "aiprofile_exported_data");
    }
  }, [isDecisionMakerExcel]);
  React.useEffect(() => {
    if (shareRecord) {
      let filter = selectedOuterRows.find((i) => i.public == false);
      if (!selectedOuterRows?.length) {
        toast.error("Please select records to share");
        setShareRecord(false);
        return;
      } else if (filter) {
        toast.error("Please select only public records to share");
        setShareRecord(false);
        return;
      }
      handleShare();
    }
  }, [shareRecord]);
  const handleShare = () => {
    let start = window.location.origin;
    let end = window.location.pathname?.split("/");
    let href = `${start}/${end[1]}/${2}`;
    const subject = encodeURIComponent(`Link to AI Lead Profile`);
    let profilesInfo = selectedOuterRows
      .map(
        (row) =>
          `Profile Name: ${row?.name}\nCreated At: ${moment(
            row?.created_at,
          ).format(
            "YYYY-MM-DD",
          )}\nOwner: ${row?.username ? row?.username : ""}`,
      )
      .join("\n\n");
    const body = encodeURIComponent(
      `Hello,\n\nHere’s an AI Profile on Orbit Intel that you may find interesting:\n\n${profilesInfo}\n\nTo view it, log into your Orbit account and navigate to AI Profile and go to the shared profiles: ${href}`,
    );
    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=${subject}&body=${body}`;
    window.open(gmailLink, "_blank");
    setSelectedOuterRows([]);
    setRowsSelectAll(false);
    setShareRecord(false);
  };

  const labelStyle = {
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 400,
    color: "#6B7280",
  };

  const valueStyle = {
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 500,
    color: "#111827",
  };
  return (
    <>
      {loading ? <Loader /> : null}
      {/* mobile code  */}
    <div className="ai-leads-table-main">
      <div className="ai-leads-no-data-available-outter">
        <div className="ai-leads-no-data-available">No Data Available</div>
      </div>
    </div>
    </>
  );
}
